import { AppRoutes } from '@consts/routes';
import { useSystemMutation, useSystemByIdQuery } from '@features/redux/apis/system';
import { MutationEffect } from '@helpers/MutationEffect';
import { QueryEffect } from '@helpers/QueryEffect';
import { useAlert } from '@hooks/useAlert';
import { useQuery } from '@hooks/useQuery';
import { useNavigate } from 'react-router-dom';

export const SystemEffects = () => {
    const stationId = useQuery().get('id');
    const navigate = useNavigate();
    const { setAlert } = useAlert();

    const queryState = useSystemByIdQuery({ id: stationId! });

    const [, mutationState] = useSystemMutation({
        fixedCacheKey: 'SystemMutation',
    });

    return (
        <>
            <QueryEffect
                queryState={queryState}
                effects={{
                    isError: () => {
                        setAlert('Failed to fetch system data', 'error');
                        navigate(AppRoutes.SystemManagement);
                    },
                }}
            />

            <MutationEffect
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                mutationState={mutationState}
                effects={{
                    isError: () => {
                        setAlert('Unable to update system.', 'error');
                        mutationState.reset();
                    },
                    isSuccess: () => {
                        setAlert('Successfully updated system', 'success');
                        navigate(AppRoutes.SystemManagement);
                        mutationState.reset();
                    },
                }}
            />
        </>
    );
};
